import _get from 'lodash/get';
import { getToolIds } from '@macmillan-learning/gradebook-shared';
import { VISIBILITY_OPTIONS } from './constants';

export function getActivityVisibilityStatus(activity) {
  const available = _get(activity, 'visibility_available_date', null);
  const until = _get(activity, 'visibility_until_date', null);
  const visibility = _get(activity, 'visibility');

  if (visibility === 'daysBefore' && available && until)
    return VISIBILITY_OPTIONS.DAYS_BEFORE;
  if ((available && !until) || visibility === VISIBILITY_OPTIONS.ALL)
    return VISIBILITY_OPTIONS.ALL;
  if ((!available && until) || visibility === VISIBILITY_OPTIONS.NONE)
    return VISIBILITY_OPTIONS.NONE;
  if (available && until) return VISIBILITY_OPTIONS.CUSTOM;

  return null;
}

export function isWritingFinalPaper(tool, parentId) {
  return tool === getToolIds().writing && !parentId;
}
